import { VisualAppState } from '../../reducer';

export const getDiffUi = (state: VisualAppState) => state.apps.visual.diffUi;
export const getOffset = (state: VisualAppState) => state.apps.visual.diffUi.offset;
